const ROOT = 'auth/';

export default {
	signIn: `${ROOT}login`,
	signOut: `${ROOT}logout`,
};
